export type Language = 'sv' | 'en'

export const translations = {
  sv: {
    // Landing
    'landing.subtitle': 'Förbeställning · Evedals Camping',
    'landing.intro':
      'Förbeställ och hämta nybakad frukost & fika i receptionskiosken.',
    'landing.cta': 'Starta din beställning',

    // PickupDay
    'pickup.heading': 'När vill du hämta?',
    'pickup.sub':
      'Förbeställ upp till 3 dagar i förväg. Beställningar måste göras senast kl. 18:00 dagen före hämtning.',
    'pickup.tomorrow': 'Imorgon',

    // Menu
    'menu.pickup': 'Hämtning',
    'menu.or_bundle': 'eller 5 för 45 kr',

    // Cart
    'cart.header': 'Granska beställning',
    'cart.pickup_date': 'Hämtningsdatum',
    'cart.pickup_info':
      'Hämta din beställning i receptionskiosken från kl. 08:00. Beställningar måste göras senast kl. 18:00 dagen före hämtning.',
    'cart.items': 'Dina varor',
    'cart.each': 'kr/st',
    'cart.bundle_savings': 'Paketrabatt',
    'cart.rolls_deal': 'Frallor: 5 för 45 kr (blanda fritt)',
    'cart.firstname_label': 'Förnamn',
    'cart.firstname_placeholder': 'Ditt förnamn',
    'cart.lastname_label': 'Efternamn',
    'cart.lastname_placeholder': 'Ditt efternamn',
    'cart.phone_label': 'Telefonnummer',
    'cart.phone_placeholder': 'T.ex. 070-123 45 67',
    'cart.notes_label': 'Meddelande (valfritt)',
    'cart.notes_placeholder': 'Allergier eller önskemål?',
    'cart.total': 'Totalt',
    'cart.payment_info':
      'Du betalar vid upphämtning i receptionskiosken. Beställningar är bindande.',
    'cart.confirm': 'Bekräfta beställning',
    'cart.submitting': 'Skickar beställning…',
    'cart.error_name':
      'Ange för- och efternamn så vi vet vem beställningen gäller.',
    'cart.error_phone': 'Ange ditt telefonnummer så vi kan nå dig vid behov.',
    'cart.error_submit': 'Det gick inte att skicka beställningen. Försök igen.',

    // OrderBar
    'orderbar.review': 'Granska beställning',
    'orderbar.item': 'vara',
    'orderbar.items': 'varor',

    // Confirmation
    'confirm.heading': 'Beställning bekräftad!',
    'confirm.sub': 'Vi har tagit emot din förbeställning.',
    'confirm.order_num': 'Beställning',
    'confirm.pickup_date': 'Hämtningsdatum',
    'confirm.order_items': 'Beställda varor',
    'confirm.total': 'Totalt',
    'confirm.instructions':
      'Visa denna skärm eller ditt beställningsnummer i receptionskiosken när du hämtar din frukost. Hämtning är möjlig från kl. 08:00.',
    'confirm.screenshot_title': 'Viktigt – spara din bekräftelse',
    'confirm.screenshot':
      'Ta en skärmbild på den här bekräftelsen, eller skriv ner ditt beställningsnummer och din hämtningsdag. Du behöver visa beställningsnummer och hämtningsdag i receptionskiosken vid upphämtning.',
    'confirm.contact_products': 'Frågor om produkterna? Ring',
    'confirm.contact_other':
      'För övriga frågor om beställningen och avbokning i sista minuten, vänd dig till receptionen.',
    'confirm.new_order': 'Gör en ny beställning',
  },
  en: {
    // Landing
    'landing.subtitle': 'Pre-order · Evedals Camping',
    'landing.intro':
      'Pre-order and pick up freshly baked breakfast & treats at the reception kiosk.',
    'landing.cta': 'Start your order',

    // PickupDay
    'pickup.heading': 'When would you like to pick up?',
    'pickup.sub':
      'Pre-order up to 3 days in advance. Orders must be placed by 6:00 PM the day before pickup.',
    'pickup.tomorrow': 'Tomorrow',

    // Menu
    'menu.pickup': 'Pickup',
    'menu.or_bundle': 'or 5 for 45 kr',

    // Cart
    'cart.header': 'Review Order',
    'cart.pickup_date': 'Pickup Date',
    'cart.pickup_info':
      'Pick up your order at the reception kiosk from 8:00 AM. Orders must be placed by 6:00 PM the day before pickup.',
    'cart.items': 'Your Items',
    'cart.each': 'kr each',
    'cart.bundle_savings': 'Bundle savings',
    'cart.rolls_deal': 'Rolls: 5 for 45 kr (mix freely)',
    'cart.firstname_label': 'First name',
    'cart.firstname_placeholder': 'Your first name',
    'cart.lastname_label': 'Last name',
    'cart.lastname_placeholder': 'Your last name',
    'cart.phone_label': 'Phone number',
    'cart.phone_placeholder': 'e.g. +46 70 123 45 67',
    'cart.notes_label': 'Order Notes (Optional)',
    'cart.notes_placeholder': 'Any allergies or special requests?',
    'cart.total': 'Total',
    'cart.payment_info':
      'You pay at pickup at the reception kiosk. Orders are binding.',
    'cart.confirm': 'Confirm Order',
    'cart.submitting': 'Placing order…',
    'cart.error_name':
      'Please enter your first and last name so we know who the order is for.',
    'cart.error_phone':
      'Please enter your phone number so we can reach you if needed.',
    'cart.error_submit': 'Failed to submit order. Please try again.',

    // OrderBar
    'orderbar.review': 'Review Order',
    'orderbar.item': 'item',
    'orderbar.items': 'items',

    // Confirmation
    'confirm.heading': 'Order Confirmed!',
    'confirm.sub': "We've received your pre-order.",
    'confirm.order_num': 'Order',
    'confirm.pickup_date': 'Pickup Date',
    'confirm.order_items': 'Ordered items',
    'confirm.total': 'Total',
    'confirm.instructions':
      'Please show this screen or your order number at the reception kiosk when picking up your breakfast. Pickup is available from 8:00 AM.',
    'confirm.screenshot_title': 'Important – save your confirmation',
    'confirm.screenshot':
      'Take a screenshot of this confirmation, or write down your order number and pickup day. You need to show your order number and pickup day at the reception kiosk when you pick up.',
    'confirm.contact_products': 'Questions about the products? Call',
    'confirm.contact_other':
      'For other questions about your order or last-minute cancellations, please contact the reception.',
    'confirm.new_order': 'Start a new order',
  },
}
